import { Component, OnInit } from '@angular/core';
import { Constants } from '@shared/services/constants';
import { NavService } from '@shared/services/nav.service';
import { SessionService } from '@shared/services/session.service';

@Component({
  selector: 'aaos-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  loading = true;
  constructor(private navService: NavService,
    private sessionService: SessionService) { }

  ngOnInit(): void {
    if (this.sessionService.checkLoggedInCookie()) {
      this.loading = false;
      this.navService.goToOverview();
    }
  }
}
